import {
  Box,
  Container,
  Grid,
  IconButton,
  Typography,
  useTheme,
} from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import {
  GetLoginActivityForm,
  GetLoginActivityList,
} from "store/api/activities";
import { useEffect, useState } from "react";

import ActivityBox from "components/SideMenuItems/Activities/Components/ActivityBox";
import BackButton from "components/BackButton";
import { Filter } from "assets/Icon";
import FilterActivities from "./Components/FilterActivities";
import Pagination from "components/Pagination";
import Table from "components/Table";
import { formatDateToJalali } from "utils/helpers/time";
import { headers } from "./Components/constants";
import http from "config/http";
import useIsMobileView from "hooks/useIsMobileView";
import { useMemo } from "react";
import useNotify from "hooks/useNotify";
import { useSearchParams } from "react-router-dom";
import { ROUTE_PATHS } from "routes/paths";

function Activities() {
  const theme = useTheme();
  const isMobileView = useIsMobileView();
  const notify = useNotify();

  const methods = useForm({
    defaultValues: {
      typeId: 0,
      startDate: "",
      endDate: "",
    },
  });

  const { watch } = methods;
  const typeId = watch("typeId");
  const startDate = watch("startDate");
  const endDate = watch("endDate");

  const [searchParams] = useSearchParams();
  const pageNumber = searchParams.get("page") || 1;
  const pageSize = searchParams.get("perPage") || 10;

  const [loginActivityList, setLoginActivityList] = useState();
  const [loginActivityForm, setLoginActivityForm] = useState();
  const [showFilter, setShowFilter] = useState(false);

  const formattedActivities = useMemo(() => {
    return loginActivityList?.data?.map((activity) => ({
      device: `${activity?.browser} | ${activity?.deviceOsName}`,
      date: activity?.date,
      time: activity?.date,
      ip: activity?.ip,
      type: (
        <Typography
          color={
            activity?.type === "Succeeded" ? "modules.checked" : "error.main"
          }
          variant="h6"
        >
          {activity?.type}
        </Typography>
      ),
    }));
  }, [loginActivityList?.data]);

  const getLoginActivityList = async ({ pageNumber, pageSize }) => {
    try {
      const { data } = await http.get(
        GetLoginActivityList({
          pageNumber,
          pageSize,
          typeId,
          startDate: formatDateToJalali(startDate),
          endDate: formatDateToJalali(endDate),
        })
      );

      setLoginActivityList(data);
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }
  };

  const getLoginActivityForm = async () => {
    try {
      const { data } = await http.get(GetLoginActivityForm);

      setLoginActivityForm(data?.data);
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }
  };

  const handleChangePaginate = ({ page, perPage }) => {
    getLoginActivityList({ pageNumber: page, pageSize: perPage });
  };

  useEffect(() => {
    getLoginActivityList({ pageNumber, pageSize, typeId });
    getLoginActivityForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getLoginActivityList({ pageSize, pageNumber });

    // eslint-disable-next-line
  }, [typeId, startDate, endDate]);

  return (
    <Container>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <BackButton text="فعالیت‌ها" to={ROUTE_PATHS.market} />
        </Grid>

        <Grid item xs={12}>
          <Typography color="text.main" dir="rtl" variant="h4">
            فعالیت ها
          </Typography>
          <Typography color="text.main" dir="rtl" variant="subtitle1">
            لیست زیر نشان دهنده‌ی فعالیت‌های حساب شما می‌باشد.
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Box display="flex" justifyContent="flex-end">
            <IconButton
              onClick={() => {
                setShowFilter((v) => !v);
              }}
              aria-label="filter"
            >
              <Filter color={theme.palette.text.main} />
            </IconButton>
          </Box>

          {showFilter && (
            <FormProvider {...methods}>
              <form>
                <FilterActivities loginActivityForm={loginActivityForm} />
              </form>
            </FormProvider>
          )}
        </Grid>

        {isMobileView ? (
          <>
            {loginActivityList?.data?.map((activity) => (
              <Grid item xs={12}>
                <ActivityBox activity={activity} />
              </Grid>
            ))}
          </>
        ) : (
          <Grid item xs={12}>
            <Table headers={headers} items={formattedActivities} />
          </Grid>
        )}

        <Grid item xs={12}>
          <Pagination
            perPage={loginActivityList?.pageSize}
            count={loginActivityList?.totalPages}
            onChange={handleChangePaginate}
          />
        </Grid>
      </Grid>
    </Container>
  );
}

export default Activities;
